import { Injectable } from "@angular/core";
import Swal, { SweetAlertIcon } from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AlertHelper {
  success(title: string, text: string) {
    return Swal.fire({
      icon: "success",
      title,
      text,
      confirmButtonText: "OK",
    });
  }

  error(title: string, text: string) {
    return Swal.fire({
      icon: "error",
      title,
      text,
      confirmButtonText: "OK",
    });
  }

  warning(title: string, text: string) {
    return Swal.fire({
      icon: "warning",
      title,
      text,
      showConfirmButton: false,
    });
  }

  confirm(
    title: string,
    text: string,
    confirmButtonText: string = "Yes",
    cancelButtonText: string = "Cancel",
    icon: SweetAlertIcon = "warning"
  ) {
    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText,
      cancelButtonText,
    });
  }
}
